import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M14.7253 12.4622L12.1875 9.92438C12.7781 8.94 13.125 7.79156 13.125 6.5625C13.125 2.94375 10.1803 0 6.5625 0C2.94469 0 0 2.94375 0 6.5625C0 10.1812 2.94469 13.125 6.5625 13.125C7.7925 13.125 8.94 12.7791 9.92438 12.1875L12.4622 14.7253C12.645 14.9081 12.885 15 13.125 15C13.365 15 13.605 14.9081 13.7878 14.7253L14.7253 13.7878C15.0919 13.4212 15.0919 12.8288 14.7253 12.4622ZM6.5625 11.25C3.97406 11.25 1.875 9.15094 1.875 6.5625C1.875 3.97406 3.97406 1.875 6.5625 1.875C9.15094 1.875 11.25 3.97406 11.25 6.5625C11.25 9.15094 9.15094 11.25 6.5625 11.25Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white"
		})
	}) })]
});
export default SvgIconSearch;
